import React, { useState } from "react";
import Banner from "../Components/Banner";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What services do you offer?",
      answer:
        "We specialize in Custom Software Development, Web & Mobile App Development, IT Services, and tailored Digital Solutions to meet your business needs.",
    },
    {
      question: "How can I start a project with you?",
      answer:
        "You can contact us via our Contact page, email info@hnhsofttechsolutions.com, or call +92 332 2901615 to schedule a consultation.",
    },
    {
      question: "What payment methods are accepted?",
      answer:
        "We accept bank transfers and major payment gateways in Pakistan. All payments are processed in PKR.",
    },
    {
      question: "Do you offer refunds?",
      answer:
        "Refunds are only available before project initiation. Completed milestones are non-refundable.",
    },
    {
      question: "What are your project timelines?",
      answer:
        "Timelines depend on project scope. A detailed timeline is shared before starting the project.",
    },
    {
      question: "Do you provide post-project support?",
      answer:
        "Yes, we offer maintenance and support services based on agreed terms.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <Banner heading="Frequently Asked Questions" text="FAQ" />

      <div className="bg-[#0b1e3a] py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-white mb-10">
            Frequently Asked Questions
          </h2>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-[#0f2b52] border border-blue-400/30 rounded-xl overflow-hidden"
              >
                {/* Question */}
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full text-left px-6 py-4 flex justify-between items-center text-white font-medium"
                >
                  {faq.question}
                  <span className="text-xl">
                    {activeIndex === index ? "-" : "+"}
                  </span>
                </button>

                {/* Answer */}
                {activeIndex === index && (
                  <div className="px-6 pb-4 text-gray-300">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;